import { render, staticRenderFns } from "./ShippingDetails.vue?vue&type=template&id=532f56cc&"
import script from "./ShippingDetails.vue?vue&type=script&lang=js&"
export * from "./ShippingDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShippingDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1768404630/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('532f56cc')) {
      api.createRecord('532f56cc', component.options)
    } else {
      api.reload('532f56cc', component.options)
    }
    module.hot.accept("./ShippingDetails.vue?vue&type=template&id=532f56cc&", function () {
      api.rerender('532f56cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/ShippingDetails.vue"
export default component.exports